import { useState, useEffect } from "react";

import config from "../config"

const useReCaptcha = (doFetch, data = null) => {
  const [response, setResponse] = useState(null)
  const [loading, setLoading] = useState(false)

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  };

  const url = config.reCaptcha.url

  useEffect(() => {
    setLoading(doFetch)
    if (doFetch) {
      fetch(url, options)
        .then((response) => response.json())
        .then((data) => setResponse(data))
        .catch((error) => console.error('Error:', error))
        .finally(() => {
          setLoading(false)
        })
    }
  }, [doFetch]);

  return {response:response, loading:loading}
}

export default useReCaptcha